import React, { PureComponent } from "react";
import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import Typography from "@material-ui/core/Typography";
import withStyles from "@material-ui/core/styles/withStyles";
import PropertyGrid from "./PropertyGrid";

class PropertySection extends PureComponent {
  render = () => {
    const {
      classes,
      title,
      header,
      section,
      shouldHide,
      expandable,
      defaultExpanded,
      children,
      variant = "h6",
      ...rest
    } = this.props;

    if (shouldHide) return null;

    const t = title && (
      <Box {...header}>
        <Typography component="div" variant={variant} color="primary">
          {title}
        </Typography>
        <Divider component="div" />
      </Box>
    );

    if (expandable) {
      return (
        <ExpansionPanel
          defaultExpanded={defaultExpanded}
          TransitionProps={{ unmountOnExit: true }}
        >
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            classes={{
              content: classes.summaryContent,
              expanded: classes.summaryContentExpanded
            }}
          >
            {t}
          </ExpansionPanelSummary>
          <ExpansionPanelDetails classes={{ root: classes.panelDetailsRoot }}>
            <PropertyGrid {...rest} />
          </ExpansionPanelDetails>
        </ExpansionPanel>
      );
    }

    return (
      <Box {...section}>
        {t}
        <PropertyGrid {...rest} />
        {children}
      </Box>
    );
  };
}

export default withStyles(
  {
    panelDetailsRoot: {
      flexDirection: "column"
    }
  },
  { name: "LcPropertySection" }
)(PropertySection);
